export const tableColumnsConfig = {
  Requests: {
    prefix: "request",
    endpoint: "requests", // 👈 endpoint used in backend URL
    columns: [
      { key: 'requestID', label: 'Request ID' },
      { key: 'requestType', label: 'Type' },
      { key: 'requestStatus', label: 'Status' },
      { key: 'requestSubject', label: 'Subject' },
      { key: 'requester', label: 'Requester ID' },
      { key: 'receiver', label: 'Receiver ID' },
      { key: 'requesterFullName', label: 'Requester Name' },
      { key: 'receiverName', label: 'Receiver Name' },
      { key: 'message', label: 'Message' },
      { key: 'location', label: 'Location' },
      { key: 'destination', label: 'Destination' },
      { key: 'reserved', label: 'Reserved' },
      { key: 'requestDate', label: 'Request Date', format: 'date' },
      { key: 'reservationDue', label: 'Reservation Due', format: 'date' },
      { key: 'cancellationDetails', label: 'Cancellation Details' },
      { key: 'lastModifiedDate', label: 'Last Modified Date', format: 'date' },
    ],
    filters: [
      {
        key: 'requestStatus',
        label: 'Status',
        options: ['pending', 'accepted', 'completed', 'canceled']
      },
      {
        key: 'requestType',
        label: 'Type',
        options: ['ride', 'safety']
      },
      {
        key: 'reserved',
        label: 'Reserved',
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' }
        ]
      }
    ]
  },

  Users: {
    prefix: "user",
    endpoint: "users",
    addEndpoint: "admin",
    deleteEndpoint: "admin", //user/admin/{uuid}
    columns: [
      { key: 'userID', label: 'User ID', editable: false },
      { key: 'username', label: 'Email', editable: true },
      // { key: 'password', label: 'Password' },
      { key: 'usertype', label: 'User Type', editable: true },
      { key: 'firstname', label: 'First Name', editable: true },
      { key: 'lastname', label: 'Last Name', editable: true },
      { key: 'phone', label: 'Phone', editable: true },
      { key: 'studentID', label: 'Student ID', editable: true },
      // { key: 'busy', label: 'Busy' },
      { key: 'verified', label: 'Verified', editable: false },
      { key: 'verificationCode', label: 'Verification Code', editable: false },
      { key: 'verificationCodeExpiry', label: 'Verification Code Expiry', format: 'date', editable: false }
    ],
    filters: [
      {
        key: 'usertype',
        label: 'User Type',
        options: ['Officer', 'Student']
      },
      {
        key: 'verified',
        label: 'Verified',
        options: [
          { label: 'Yes', value: 'true' },
          { label: 'No', value: 'false' }
        ]
      }
    ],
    editable: false,
    creatable: true,
    deletable: true
  },

  // Location_Options: {
  //   prefix: "option",
  //   endpoint: "locationOptions",
  //   columns: [
  //     { key: 'locationOptionID', label: 'Location ID' },
  //     { key: 'locationName', label: 'Location Name' },
  //   ]
  // },

  Location_Options: {
    prefix: "option",
    endpoint: "locationOptions", // for loading the table itself
    addEndpoint: "location", // for adding a row to the table
    deleteEndpoint: "location",
    columns: [
      { key: 'locationOptionID', label: 'Location ID', editable: false },  // Primary key, not editable
      { key: 'locationName', label: 'Location Name', editable: true },     // Editable & required for Add
    ],
    editable: false,     // Will be true when you add edit buttons
    creatable: true,     // Enables the Add Form
    deletable: true     // when you want to support delete
  },

  Officer_Driver_Options: {
    prefix: "option",
    endpoint: "officerDriverOptions",
    addEndpoint: "officer/driver",
    deleteEndpoint: "officer/driver",
    columns: [
      { key: 'officerDriverOptionID', label: 'Option ID', editable: false },
      { key: 'firstname', label: 'First Name', editable: true },
      { key: 'lastname', label: 'Last Name', editable: true },
      { key: 'type', label: 'Type', editable: true }
    ],
    editable: false,
    creatable: true,
    deletable: true
  },

  Request_Options: {
    prefix: "option",
    endpoint: "requestOptions",
    addEndpoint: "request",
    deleteEndpoint: "request",
    columns: [
      { key: 'requestOptionID', label: 'Option ID', editable: false },
      { key: 'requestTitle', label: 'Title', editable: true }
    ],
    editable: false,
    creatable: true,
    deletable: true
  },

  Chat_Message: {
    prefix: "chat",
    endpoint: "messages",
    columns: [
      { key: 'chatMessageID', label: 'Message ID' },
      { key: 'senderID', label: 'Sender ID' },
      { key: 'receiverID', label: 'Receiver ID' },
      { key: 'senderFullName', label: 'Sender' },
      { key: 'receiverFullName', label: 'Receiver' },
      { key: 'messageContent', label: 'Content' },
      { key: 'messageTimestamp', label: 'Time Stamp' }
    ]
  },

  Announcements: {
    prefix: "announcements",
    endpoint: "announcements",   // 👈 new admin list endpoint
    addEndpoint: "announcements",
    deleteEndpoint: "announcements",
    columns: [
      { key: 'id', label: 'ID', editable: false },
      { key: 'title', label: 'Title', editable: true },
      { key: 'message', label: 'Message', editable: true },
      { key: 'severity', label: 'Severity', editable: true },
      { key: 'linkText', label: 'Link Text', editable: true },
      { key: 'linkUrl', label: 'Link URL', editable: true },
      { key: 'minVersion', label: 'Min Version', editable: true },
      { key: 'maxVersion', label: 'Max Version', editable: true },
      { key: 'required', label: 'Required', editable: true },
      { key: 'showOncePerVersion', label: 'Show Once/Version', editable: true },
      { key: 'audience', label: 'Audience', editable: true },
      { key: 'startAt', label: 'Start At', format: 'date', editable: true },
      { key: 'endAt', label: 'End At', format: 'date', editable: true },
      { key: 'platformsCsv', label: 'Platforms', editable: true },
      { key: 'enabled', label: 'Enabled', editable: true },
      { key: 'priority', label: 'Priority', editable: true }
    ],
    editable: false,
    creatable: true,
    deletable: true
  }
  


  // ...add more
};
